import { createConfig, http } from 'wagmi';
import { injected } from 'wagmi/connectors';
import { mainnet, sepolia } from 'viem/chains';

// Create wagmi config with injected connector
// Only supports: MetaMask, Phantom, and OneKey wallets
// The injected connector will detect these wallets when available
export const wagmiConfig = createConfig({
  chains: [mainnet, sepolia],
  connectors: [
    injected(), // Detects MetaMask, Phantom, and OneKey wallets
  ],
  transports: {
    [mainnet.id]: http(),
    [sepolia.id]: http(),
  },
});

